import React, { memo } from 'react';
import {
  Button,
  Card,
  Collapse,
  Divider,
  HStack,
  Icon,
  Text,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';

import GrayTextBox from '@company-scan/components/GrayTextBox';
import useAnvaFlowProductSelectionStore from '@flows/src/store/zustand/flows-products/useAnvaFlowProductSelectionStore';
import AnvaProductCartWidgetItems from '@flows/src/components/flow-products/quotes/cart/AnvaProductCartWidgetItems';

const AnvaProductCartWidget: React.FC = () => {
  const { t } = useTranslation();
  const selectedItems = useAnvaFlowProductSelectionStore(
    (state) => state.selectedItems,
  );
  const resetStore = useAnvaFlowProductSelectionStore((state) => state.reset);

  return (
    <Card boxShadow="none" p="0" mx="4" overflow="hidden" borderColor="gray.50">
      <HStack spacing="2" py="2" px="3">
        <Icon name="GeneralNavigationProducts" color="gray.500" boxSize={5} />
        <Text textStyle="normalBodyMedium">
          {t('FLOWS_PRODUCT-CART_WIDGET_TITLE')}
        </Text>
      </HStack>
      <Collapse in={!selectedItems.length}>
        <>
          <Divider borderColor="gray.50" />
          <GrayTextBox borderRadius="none" border="none" color="gray.300">
            {t('FLOWS_PRODUCT-CART_WIDGET_EMPTY_TEXT')}
          </GrayTextBox>
        </>
      </Collapse>
      <AnvaProductCartWidgetItems quotes={selectedItems} />
      <Divider borderColor="gray.50" />
      <Button
        variant="white"
        size={{ base: 'sm', laptop: 'md' }}
        borderRadius="none"
        color="primary.500"
        border="none"
        onClick={resetStore}
      >
        {t('FLOWS_PRODUCT-CART_WIDGET_ACTION')}
      </Button>
    </Card>
  );
};

export default memo(AnvaProductCartWidget);
